
const state = {
  graphPage: false,
  gridVue: false,
  gridPopup: false,
  linePdf: false,
  singlePagePdf: false,
  multiPdf: false,
  mainGraph: false
};

const getters = {
  graphPage(state) {
    return state.graphPage;
  },
  gridVue(state) {
    return state.gridVue;
  },
  gridPopup(state) {
    return state.gridPopup;
  },
  linePdf(state) {
    return state.linePdf;
  },
  singlePagePdf(state) {
    return state.singlePagePdf;
  },
  multiPdf(state) {
    return state.multiPdf;
  },
  mainGraph(state) {
    return state.mainGraph;
  }

};

const mutations = {
  closePage(state, name) {
    state[name] = false;
  },
  openPage(state, name) {
    state[name] = true;
  }
};

export default {
  state,
  getters,
  mutations
};